import { gql, useQuery } from '@apollo/client';
export const GET_QUESTION_VISIBILITY_DATA = gql `
  query getQuestionVisibilityData(
    $eventId: ID!
    $eventSnapshotVersion: String!
    $environment: String!
    $accountSnapshotVersion: String!
    $regPathId: String!
    $isGuest: Boolean!
  ) {
    eventId @client @export(as: "eventId")
    environment @client @export(as: "environment")
    eventSnapshotVersion @client @export(as: "eventSnapshotVersion")
    accountSnapshotVersion @client @export(as: "accountSnapshotVersion")
    event(
      input: {
        eventId: $eventId
        eventSnapshotVersion: $eventSnapshotVersion
        accountSnapshotVersion: $accountSnapshotVersion
        environment: $environment
      }
    ) {
      id
      questionsWithVisibilityLogic(regPathId: $regPathId, isGuest: $isGuest) {
        questionsWithVisibilityLogic {
          id
          productQuestionAssociations
        }
        questionLinkedWithFieldId {
          fieldId
          questionIds
        }
      }
    }
  }
`;
export function useQuestionVisibilityData(regPathId, isGuest) {
    var _a;
    const { data, loading } = useQuery(GET_QUESTION_VISIBILITY_DATA, {
        variables: {
            regPathId,
            isGuest
        }
    });
    return {
        questions: (_a = data === null || data === void 0 ? void 0 : data.event) === null || _a === void 0 ? void 0 : _a.questionsWithVisibilityLogic,
        isLoading: loading
    };
}
export async function getVisibilityDetailsFromGql(regPathId, isGuests, apolloClient) {
    return await apolloClient.query({
        query: GET_QUESTION_VISIBILITY_DATA,
        variables: {
            regPathId,
            isGuest: isGuests
        }
    });
}
